import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import Slider from 'react-slick';
import { useTranslation } from 'react-i18next';
import Slide0 from '../../assets/img/aboutSolid/slide0.png';
import Slide1 from '../../assets/img/aboutSolid/slide1.png';
import Slide2 from '../../assets/img/aboutSolid/slide2.png';
import Slide3 from '../../assets/img/aboutSolid/slide3.png';
import Slide4 from '../../assets/img/aboutSolid/slide4.png';
import Slide5 from '../../assets/img/aboutSolid/slide5.png';
import Slide6 from '../../assets/img/aboutSolid/slide6.png';
import Slide7 from '../../assets/img/aboutSolid/slide7.png';
import Slide8 from '../../assets/img/aboutSolid/slide8.png';

const SectionContainer = styled.div`
  background-color: #f2f7f7;
`;

const Title = styled.h1`
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 30px;
  line-height: 39px;
  letter-spacing: -0.02em;
  color: #1c3245;
  margin: 0;
  padding: 0;
  max-width: 544px;
`;

const Desc = styled.p`
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 26px;
  color: #353433;
  margin: 0;
  padding: 0;
  max-width: 544px;
`;

const StyledSlider = styled(Slider)`
  .row {
    display: flex !important;
  }
  .slick-list {
    margin-bottom: 15px;
  }
  .slick-dots li button:before {
    font-size: 10px;
  }
  .slick-dots li.slick-active button:before {
  color: #1E1E1E;
  }
`;

const ImageContainer = styled.div`
  height: 100%;
  max-width: 500px;
  background-color: #FFFFFF;
  border-radius: 40px;
`;

const SlideText = styled.p`
  font-family: 'Warbler Text';
  font-style: normal;
  font-weight: 400;
  font-size: 30px;
  line-height: 38px;
  color: #353433;
  margin: 0;
  padding: 0;
  text-align: left;
`;

const SlideTextContainer = styled.div`
  max-width: 330px;
`;

const SlideNumberDiv = styled.span`
  background: #EAAC34;
  border-radius: 50%;
  width: auto;
  padding: 8px 20px;
  font-family: 'IBM Plex Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 39px;
  letter-spacing: -0.02em;
  color: #1C3245;
`;

const StyledArrow = styled.div`
  ::before {
    color: #000000
  }
`;

export const LiquidSlider = () => {
  const [width, setWidth] = useState(window.innerWidth);
  let isMobile = width <= 768;
  const [t, i18n] = useTranslation('global');
  const Items = [
    {
      image: Slide0,
      text: t('liquid.slider.slide-zero'),
    },
    {
      image: Slide1,
      text: t('liquid.slider.slide-one'),
    },
    {
      image: Slide2,
      text: t('liquid.slider.slide-two'),
    },
    {
      image: Slide3,
      text: t('liquid.slider.slide-three'),
    },
    {
      image: Slide4,
      text: t('liquid.slider.slide-four'),
    },
    {
      image: Slide5,
      text: t('liquid.slider.slide-five'),
    },
    {
      image: Slide6,
      text: t('liquid.slider.slide-six'),
    },
    {
      image: Slide7,
      text: t('liquid.slider.slide-seven'),
    },
    {
      image: Slide8,
      text: t('liquid.slider.slide-eight'),
    },
  ];

  const CustomArrow = (props) => {
    const {className, style, onClick} = props;
    return(
      <>
        {!isMobile && (
          <StyledArrow
            className={className}
            style={{...style, display: 'block'}}
            onClick={onClick}
          />
        )}
      </>
    );
  }

  const settings = {
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    nextArrow: <CustomArrow />,
    prevArrow: <CustomArrow />
  };

  function handleWindowSizeChange() {
    setWidth(window.innerWidth);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, []);

  return (
    <SectionContainer className='pt-5 pb-5'>
      <Container className='pt-3 pb-3'>
        <Row className={`${isMobile ? 'mb-4' : 'mb-5'}`}>
          <Col xs={12}>
            <Row className='justify-content-center mb-4'>
              <Title>
                {t('liquid.how-it-works.title')}
              </Title>
            </Row>
            <Row className='justify-content-center'>
              <Desc data-aos="fade-up">
                {t('liquid.how-it-works.desc')}
              </Desc>
            </Row>
          </Col>
        </Row>
        <Row data-aos="fade-up">
          <StyledSlider {...settings} className='pt-4 pb-4'>
            {Items.map((item, index) => (
              <Row key={index}>
                <Col xs={12} sm={12} md={6} className='mb-4'>
                  <ImageContainer>
                    <img
                      src={item.image}
                      alt={`Ilustración de paso ${index + 1}`}
                      className='img-fluid'
                    />
                  </ImageContainer>
                </Col>
                <Col xs={12} sm={12} md={6}>
                  <Row className='align-items-center justify-content-center h-100'>
                    <SlideTextContainer>
                      <div className='mb-3 d-flex flex-row justify-content-start'>
                        <SlideNumberDiv>
                          {index + 1}
                        </SlideNumberDiv>
                      </div>
                      <div className='w-auto'>
                        <SlideText>
                          {item.text}
                        </SlideText>
                      </div>
                    </SlideTextContainer>
                  </Row>
                </Col>
              </Row>
            ))}
          </StyledSlider>
        </Row>
      </Container>
    </SectionContainer>
  );
};
